<template>
    <div class="media">
        <img :src="media.src" alt="" class="splash-thumb" @contextmenu.prevent @drag.prevent @dragstart.prevent>

        <img :src="media.src" v-if="media.src" alt="" :width="media.width"
             :height="media.height"
             class="full-image"
             @contextmenu.prevent @drag.prevent @dragstart.prevent>

        <div class="embed" v-if="media.embed" v-html="media.embed"
             :style="aspectRatio"></div>
    </div>
</template>

<script>
export default {
    name: "Media",

    props: {
        media: {},
        aspectRatio: {},
    },

    data() {
        return {};
    },

    methods: {}
}
</script>

<style lang="scss" scoped>

.splash-thumb {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    filter: blur(10px);
    object-fit: cover;
    opacity: .5;
}

.media {
    height: 100%;
    position: relative;
    transition: all 0.15s cubic-bezier(0.65, 0.05, 0.36, 1);

    img {
        height: 100%;
        width: auto;
        display: block;
        margin: auto;
        transition: all 0.3s ease-in-out;
    }

    .splash-thumb {
        width: 100%;
        height: 100%;
        z-index: -1;
        //display: none;
    }
}

.full-image {
    object-fit: contain;
}

.embed {
    .has-details & {
        height: 100%;
        aspect-ratio: auto !important;
    }
}

.embed:deep iframe {
    display: block;
    width: 100%;
    height: 100%;
}


.has-details .media {
    height: 20%;

    img:not(.splash-thumb) {
        opacity: 0;
    }

    .splash-thumb {
        filter: blur(0);
        opacity: 1;
        display: block;
    }
}


</style>